import { FC } from 'react';

import DataTable from 'components/DataTable';

import { formatCurrencyToShort } from 'utils/format-helper';

import { useSyndicateAnalyticsData } from '.';

const DpiBreakdown: FC = () => {
  const { analytics } = useSyndicateAnalyticsData();

  return (
    <div className="space-y-6 mb-12">
      <section className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
        <h2 className="text-lg font-semibold text-gray-900">DPI Breakdown</h2>
        <p className="mt-1 text-sm text-gray-500">
          Overall DPI is {analytics.overview.dpi.toFixed(2)}x, built from scheme-level realized
          distributions over total paid-in capital.
        </p>
        <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-3">
          <div className="rounded-xl bg-gray-50 px-4 py-3">
            <p className="text-xs uppercase tracking-wide text-gray-500">Overall DPI</p>
            <p className="mt-1 text-2xl font-semibold text-gray-900">
              {analytics.overview.dpi.toFixed(2)}x
            </p>
          </div>
          <div className="rounded-xl bg-gray-50 px-4 py-3">
            <p className="text-xs uppercase tracking-wide text-gray-500">Total Realized Value</p>
            <p className="mt-1 text-2xl font-semibold text-gray-900">
              {formatCurrencyToShort(analytics.overview.totalRealizedValue)}
            </p>
          </div>
          <div className="rounded-xl bg-gray-50 px-4 py-3">
            <p className="text-xs uppercase tracking-wide text-gray-500">Total Invested</p>
            <p className="mt-1 text-2xl font-semibold text-gray-900">
              {formatCurrencyToShort(analytics.overview.totalInvestedAmount)}
            </p>
          </div>
        </div>
      </section>

      <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
        <div className="p-6">
          <DataTable
            data={analytics.dpiBreakdown}
            searchFields={['schemeName']}
            columns={[
              {
                label: 'Scheme',
                fieldName: 'schemeName',
              },
              {
                label: 'Invested Capital',
                fieldName: 'investedCapital',
                type: 'CURRENCY',
              },
              {
                label: 'Realized Value',
                fieldName: 'realizedValue',
                type: 'CURRENCY',
              },
              {
                label: 'Scheme DPI',
                fieldName: 'dpi',
                type: 'MULTIPLE',
              },
              {
                label: 'Contribution To Overall DPI',
                fieldName: 'contributionToOverallDpi',
                type: 'PERCENTAGE',
                headerNote:
                  'This is each scheme’s realized value divided by the syndicate’s total invested capital, so the contributions sum to the overall DPI.',
              },
            ]}
            emptyListTitle="No DPI data yet"
            emptyListDescription="DPI breakdown appears once realized distributions are available for the syndicate."
          />
        </div>
      </section>
    </div>
  );
};

export default DpiBreakdown;
